/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sets: NonNullable<unknown>, sessions: NonNullable<unknown> }} Wrapped_Period_Top_RowInputs */

const en_us2_wrapped_period_top_row = /** @type {(inputs: Wrapped_Period_Top_RowInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`1 workout · ${i?.sets} sets`);
	return /** @type {LocalizedString} */ (`${i?.sessions} workouts · ${i?.sets} sets`)
	
};

const pt_br2_wrapped_period_top_row = /** @type {(inputs: Wrapped_Period_Top_RowInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`1 treino · ${i?.sets} séries`);
	return /** @type {LocalizedString} */ (`${i?.sessions} treinos · ${i?.sets} séries`)
	
};

const es_419_wrapped_period_top_row = /** @type {(inputs: Wrapped_Period_Top_RowInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`1 entrenamiento · ${i?.sets} series`);
	return /** @type {LocalizedString} */ (`${i?.sessions} entrenamientos · ${i?.sets} series`)
	
};

const pt_pt2_wrapped_period_top_row = /** @type {(inputs: Wrapped_Period_Top_RowInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`1 treino · ${i?.sets} séries`);
	return /** @type {LocalizedString} */ (`${i?.sessions} treinos · ${i?.sets} séries`)
	
};

const fr_fr2_wrapped_period_top_row = /** @type {(inputs: Wrapped_Period_Top_RowInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`1 séance · ${i?.sets} séries`);
	return /** @type {LocalizedString} */ (`${i?.sessions} séances · ${i?.sets} séries`)
	
};

const de_de2_wrapped_period_top_row = /** @type {(inputs: Wrapped_Period_Top_RowInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`1 Training · ${i?.sets} Sätze`);
	return /** @type {LocalizedString} */ (`${i?.sessions} Trainings · ${i?.sets} Sätze`)
	
};

const it_it2_wrapped_period_top_row = /** @type {(inputs: Wrapped_Period_Top_RowInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`1 allenamento · ${i?.sets} serie`);
	return /** @type {LocalizedString} */ (`${i?.sessions} allenamenti · ${i?.sets} serie`)
	
};

/**
* | sessions | output |
* | --- | --- |
* | "1" | "1 workout · {sets} sets" |
* | * | "{sessions} workouts · {sets} sets" |
*
* @param {Wrapped_Period_Top_RowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_top_row = /** @type {((inputs: Wrapped_Period_Top_RowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Top_RowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_top_row(inputs)
	if (locale === "es-419") return es_419_wrapped_period_top_row(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_top_row(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_top_row(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_top_row(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_top_row(inputs)
	return en_us2_wrapped_period_top_row(inputs)
});
export { wrapped_period_top_row as "wrapped-period.top_row" }